<!-- league filters -->
@if (authService.hasPermission(AppPermissionCodes.Leagues_Dashboard_Filter)) {
<div class="row gx-3 gy-2 mb-4">
	<div class="col-24 col-sm-6">
		<input class="form-control form-control-search" type="search" autocomplete="noautocomplete"
			placeholder="Search leagues..." aria-label="text search filter" [(ngModel)]="filters.q"
			(ngModelChange)="onFiltersChange()">
		<!-- [readOnly]="leaguesLoading" -->
	</div>
	<div class="col-12 col-sm-auto">
		<select id="regionSelect" name="regionSelect" class="form-select" [class.fw-bold]="filters.regionID"
			aria-label="region filter" [(ngModel)]="filters.regionID" (change)="onFiltersChange()"
			[disabled]="leaguesLoading">
			<option [ngValue]="null" selected>All Regions</option>
			@for (region of (regionsLookup$ | async); track region.id) {
			<option [ngValue]="region.id">{{ region.name }}</option>
			}
		</select>
	</div>
	<div class="col-12 col-sm-auto">
		<select id="zoneSelect" name="zoneSelect" class="form-select" [class.fw-bold]="filters.zoneID"
			aria-label="zone filter" [(ngModel)]="filters.zoneID" (change)="onFiltersChange()"
			[disabled]="leaguesLoading">
			<option [ngValue]="null" selected>All Zones</option>
			@for (zone of (zonesLookup$ | async); track zone.id) {
			<option [ngValue]="zone.id">{{ zone.name }}</option>
			}
		</select>
	</div>
	<div class="col-24 col-sm-auto">
		<div class="row g-0 g-sm-3 align-items-center">
			<div class="col-auto">
				<label class="col-form-label">Affiliation status</label>
			</div>
			<div class="col-auto">
				<div class="px-2 py-2 border bg-white">
					<div class="form-check form-check-inline">
						<input id="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.NotStarted }}"
							class="form-check-input" type="checkbox" [value]="true"
							[(ngModel)]="filters.affiliationStatuses.notStarted" (change)="onFiltersChange()"
							[disabled]="leaguesLoading">
						<label class="form-check-label"
							for="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.NotStarted }}">Not
							Started</label>
					</div>
					<div class="form-check form-check-inline">
						<input id="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Draft }}"
							class="form-check-input" type="checkbox" [value]="true"
							[(ngModel)]="filters.affiliationStatuses.draft" (change)="onFiltersChange()"
							[disabled]="leaguesLoading">
						<label class="form-check-label"
							for="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Draft }}">Draft</label>
					</div>
					<div class="form-check form-check-inline">
						<input id="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Submitted }}"
							class="form-check-input" type="checkbox" [value]="true"
							[(ngModel)]="filters.affiliationStatuses.submitted" (change)="onFiltersChange()"
							[disabled]="leaguesLoading">
						<label class="form-check-label"
							for="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Submitted }}">Submitted</label>
					</div>
					<div class="form-check form-check-inline">
						<input id="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Rejected }}"
							class="form-check-input" type="checkbox" [value]="true"
							[(ngModel)]="filters.affiliationStatuses.rejected" (change)="onFiltersChange()"
							[disabled]="leaguesLoading">
						<label class="form-check-label"
							for="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Rejected }}">Rejected</label>
					</div>
					<div class="form-check form-check-inline">
						<input id="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Approved }}"
							class="form-check-input" type="checkbox" [value]="true"
							[(ngModel)]="filters.affiliationStatuses.approved" (change)="onFiltersChange()"
							[disabled]="leaguesLoading">
						<label class="form-check-label"
							for="affAppStatusCheckbox{{ AffiliationApplicationStatusCodes.Approved }}">Approved</label>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-24 col-sm-auto hstack">
		<div class="form-check form-switch">
			<input id="agreementSwitch" class="form-check-input" type="checkbox" role="switch"
				[(ngModel)]="filters.leagueAgreementSubmitted" (change)="onFiltersChange()" [disabled]="leaguesLoading">
			<label class="form-check-label" for="agreementSwitch">League agreement submitted?</label>
		</div>
	</div>
	<div class="col-24 col-sm-auto hstack">
		<div class="form-check form-switch">
			<input id="tournamentSwitch" class="form-check-input" type="checkbox" role="switch"
				[(ngModel)]="filters.tournamentApplicationSubmitted" (change)="onFiltersChange()"
				[disabled]="leaguesLoading">
			<label class="form-check-label" for="tournamentSwitch">Tournament app submitted?</label>
		</div>
	</div>
	<div class="col-24 col-sm-auto hstack">
		<div class="form-check form-switch">
			<input id="incompleteTeamsSwitch" class="form-check-input" type="checkbox" role="switch"
				[(ngModel)]="filters.incompleteTeams" (change)="onFiltersChange()" [disabled]="leaguesLoading">
			<label class="form-check-label" for="incompleteTeamsSwitch">Has incomplete teams?</label>
		</div>
	</div>
	<div class="col-24 col-sm-auto hstack">
		<div class="form-check form-switch">
			<input id="missingDocsSwitch" class="form-check-input" type="checkbox" role="switch"
				[(ngModel)]="filters.missingDocuments" (change)="onFiltersChange()" [disabled]="leaguesLoading">
			<label class="form-check-label" for="missingDocsSwitch">Has missing docs?</label>
		</div>
	</div>
</div>

<hr />
}

<!-- ACTIVE LEAGUES -->
<!-- active leagues title -->
<!-- d-none d-sm-flex -->
<div class="row mb-3">
	<div class="col">
		@if (authService.hasPermission(AppPermissionCodes.Leagues_Dashboard_Filter)) {
		<!-- users with filtering permissions that would see both active and inactive leagues (TODO: NEED BETTER PERMISSIONS) -->
		<h1 class="mb-0">
			Active Leagues
			@if (activeLeagues.length) { <span class="text-secondary">({{ activeLeagues.length | number }})</span> }
			<fa-icon class="text-secondary ms-2" size="xs" [icon]="infoIcon"
				ngbTooltip="Leagues that affiliated with RBI during the current and/or previous league years." />
		</h1>
		} @else {
		<h1 class="mb-0">
			Leagues
			@if (activeLeagues.length) { <span class="text-secondary">({{ activeLeagues.length | number }})</span> }
		</h1>
		}
	</div>
	@if (authService.hasPermission(AppPermissionCodes.League_Create)) {
	<div class="col-auto">
		<!-- DESKTOP -->
		<div class="d-none d-sm-block">
			<button class="btn btn-lg btn-primary" [routerLink]="['/leagues/new']">
				<fa-icon class="me-2" [icon]="addIcon" /> Add League
			</button>
		</div>
		<!-- MOBILE -->
		<div class="d-block d-sm-none">
			<button class="btn btn-primary" [routerLink]="['/leagues/new']">
				<fa-icon [icon]="addIcon" />
			</button>
		</div>
	</div>
	}
</div>

<!-- active league listing -->
<div class="row mb-5">
	<div class="col">
		<!-- DESKTOP VIEW -->
		<div class="card d-none d-xl-flex" [class.border-0]="activeLeagues.length">
			<div class="card-body" [class.p-0]="activeLeagues.length || leaguesLoading">
				@if (leaguesLoading) {
				<app-table-placeholder [columnsCount]="4" [rowsCount]="4" />
				} @else if (leaguesError) {
				<app-error message="Error loading leagues" (retry)="onLoadLeagues()" />
				} @else if (!activeLeagues.length) {
				<app-empty message="no leagues for league year {{ globalFiltersService.getLeagueYearName() }}" />
				} @else {
				<div class="table-responsive">
					<table class="table table-hover table-bordered align-middle mb-0">
						<thead class="table-secondary">
							<tr>
								<th scope="col">League</th>
								<th class="text-center" scope="col">Affiliation</th>
								<th scope="col">Applications & Agreements</th>
								<th class="text-center" scope="col">Documents</th>
								<th scope="col">Contacts</th>
							</tr>
						</thead>
						<tbody>
							@for (league of activeLeagues; track league.leagueID; let isLast = $last, isOdd = $odd) {
							<tr class="stretchable-container table-row-clickable">
								<td class="align-top">
									<div class="row g-2 align-items-center">
										@if (league.logoThumbnailURL) {
										<div class="col-auto">
											@defer (on viewport) {
											<app-document-thumbnail [thumbnailURL]="league.logoThumbnailURL"
												[isCircle]="false" />
											} @placeholder {
											<app-spinner />
											}
										</div>
										}
										<div class="col">
											<!-- league name -->
											<h5 class="hstack gap-2">
												<a class="text-reset text-decoration-none stretched-link"
													[routerLink]="['/leagues/', league.leagueID]">{{
													league.leagueName
													}}</a>
												@if (league.isGuestAccess) { <span class="badge text-bg-light"
													ngbTooltip="Guest access"><fa-icon class="me-1"
														[icon]="guestUserIcon" /> Guest</span> }
											</h5>
											<!-- team counts -->
											<div class="d-flex align-items-center gap-2">
												<app-teams-badge [teamCount]="league.teamCount"
													[hasWarning]="league.hasTeamWarning" />
												<app-players-badge [playerCount]="league.actualPlayerCount"
													[teamCount]="league.teamCount"
													[hasWarning]="league.hasPlayerWarning"
													[hasSuccess]="league.hasPlayerSuccess" />
												<app-coaches-badge [coachCount]="league.actualCoachCount"
													[teamCount]="league.teamCount"
													[hasWarning]="league.hasCoachWarning" />
												<app-location-badge [countryCode]="league.countryCode"
													[zoneName]="league.zoneName" />
											</div>
											<!-- league address -->
											@if (league.leagueFullAddress) {
											<div class="mt-1">
												<small class="text-secondary">
													{{ league.leagueFullAddress }}
												</small>
											</div>
											}
										</div>
									</div>
								</td>
								<td class="align-top text-center">
									<app-years-badge [leagueYears]="league.affiliationYears || '-'" />
								</td>
								<td class="align-top text-nowrap">
									<div class="hstack gap-2 mb-1">
										<app-status-icon [statusType]="StatusTypes.AffiliationApplication"
											[statusCode]="league.affiliationApplicationStatusCode"
											[statusName]="league.affiliationApplicationStatusName" size="xs" />
										<span class="small">Affiliation Application</span>
									</div>
									<div class="hstack gap-2 mb-1">
										<app-status-icon [statusType]="StatusTypes.LeagueAgreement"
											[statusCode]="league.isLeagueAgreementSubmitted ? LeagueAgreementStatusCodes.Submitted : LeagueAgreementStatusCodes.NotSubmitted"
											[statusName]="league.isLeagueAgreementSubmitted ? 'Submitted' : 'Not Submitted'"
											size="xs" />
										<span class="small">League Agreement</span>
									</div>
									<div class="hstack gap-2">
										<app-status-icon [statusType]="StatusTypes.TournamentApp"
											[statusCode]="league.tournamentApplicationStatusID"
											[statusName]="league.tournamentApplicationStatusName" size="xs" />
										<span class="small">Tournament Application</span>
									</div>
								</td>
								<td class="align-top text-center">
									<app-documents-badge
										[inProgressCount]="league.requiredInProgressDocumentCount + league.optionalInProgressDocumentCount"
										[approvedCount]="league.requiredApprovedDocumentCount + league.optionalApprovedDocumentCount"
										[totalCount]="league.totalRequiredDocumentCount + league.totalOptionalDocumentCount"
										[hasWarning]="league.hasDocumentWarning"
										[hasSuccess]="league.hasDocumentSuccess" />
								</td>
								<td class="align-top">
									<!-- primary contact -->
									<div class="small">
										@if (league.primaryContactName) {
										<div class="fw-medium">{{ league.primaryContactName }}</div>
										}
										@if (league.primaryContactPhone) {
										<div><a href="tel:{{ league.primaryContactPhone }}">{{
												league.primaryContactPhone }}</a></div>
										}
										@if (league.primaryContactEmail) {
										<div><a href="mailto:{{ league.primaryContactEmail }}">{{
												league.primaryContactEmail }}</a></div>
										}
									</div>

									<!-- contacts separator -->
									@if ((league.primaryContactName || league.primaryContactPhone ||
									league.primaryContactEmail) && (league.secondaryContactName ||
									league.secondaryContactPhone ||
									league.secondaryContactEmail)) {
									<hr class="my-2" />
									}

									<!-- secondary contact -->
									<div class="small">
										@if (league.secondaryContactName) {
										<div class="fw-medium">{{ league.secondaryContactName }} <span
												class="fw-normal text-secondary">(secondary)</span>
										</div>
										}
										<!-- @else {
										<div>SECONDARY:</div>
										} -->
										@if (league.secondaryContactPhone) {
										<div><a href="tel:{{ league.secondaryContactPhone }}">{{
												league.secondaryContactPhone }}</a></div>
										}
										@if (league.secondaryContactEmail) {
										<div><a href="mailto:{{ league.secondaryContactEmail }}">{{
												league.secondaryContactEmail }}</a></div>
										}
									</div>
								</td>
							</tr>
							}
						</tbody>
						@if (leaguesLoading) {
						<tfoot>
							<tr>
								<td colspan="5">
									<app-table-placeholder [columnsCount]="5" [rowsCount]="4"></app-table-placeholder>
								</td>
							</tr>
						</tfoot>
						}
					</table>
				</div>
				}
			</div>
		</div>

		<!-- MOBILE VIEW -->
		<div class="row g-3 d-flex d-xl-none">
			@if (leaguesLoading) {
			<div class="col-24 col-sm-12"><app-card-placeholder [hasTitle]="true" [listItemCount]="3"
					[bodyRowItemCounts]="[[4]]" [twoLineItems]="false" /></div>
			<div class="col-24 col-sm-12"><app-card-placeholder [hasTitle]="true" [listItemCount]="3"
					[bodyRowItemCounts]="[[4]]" [twoLineItems]="false" /></div>
			@if (authService.hasPermission(AppPermissionCodes.League_Update)) {
			<div class="col-24 col-sm-12"><app-card-placeholder [hasTitle]="true" [listItemCount]="3"
					[bodyRowItemCounts]="[[4]]" [twoLineItems]="false" /></div>
			<div class="col-24 col-sm-12"><app-card-placeholder [hasTitle]="true" [listItemCount]="3"
					[bodyRowItemCounts]="[[4]]" [twoLineItems]="false" /></div>
			<div class="col-24 col-sm-12"><app-card-placeholder [hasTitle]="true" [listItemCount]="3"
					[bodyRowItemCounts]="[[4]]" [twoLineItems]="false" /></div>
			}
			} @else if (leaguesError) {
			<div class="col-24"><app-error message="Error loading leagues" (retry)="onLoadLeagues()" /></div>
			} @else if (!activeLeagues.length) {
			<div class="col-24"><app-empty
					message="No leagues for league year {{ globalFiltersService.getLeagueYearName() }}" /></div>
			} @else {
			@for (league of activeLeagues; track league.leagueID; let isLast = $last, isOdd = $odd) {
			<div class="col-24 col-sm-12">
				<div class="card border-2">
					<div class="card-body">
						<div class="card-title c-pointer mb-3" [routerLink]="['/leagues/', league.leagueID]">
							<!-- title -->
							<div class="d-flex justify-content-between">
								<h3 class="mb-0">
									@if (league.logoThumbnailURL) {
									<app-document-thumbnail class="me-1" [thumbnailURL]="league.logoThumbnailURL"
										[isCircle]="false" size="sm" />
									}
									{{ league.leagueName }}
								</h3>
								<app-details-icon ngbTooltip="View League Details" />
							</div>
							<!-- region/zone/affiliations -->
							<div class="hstack gap-2 flex-wrap mt-2">
								@if (league.isGuestAccess) { <span class="badge text-bg-light"
									ngbTooltip="Guest access"><fa-icon [icon]="guestUserIcon" /></span> }
								<app-location-badge [countryCode]="league.countryCode" [zoneName]="league.zoneName" />
								<app-years-badge [leagueYears]="league.affiliationYears || '-'" />
							</div>
							<!-- league address -->
							@if (league.leagueFullAddress) {
							<div class="mt-2 small text-secondary">
								{{ league.leagueFullAddress }}
							</div>
							}
						</div>

						<!-- application & agreement statuses -->
						<hr class="mt-1 mb-3" />

						<div class="row mb-1">
							<div class="col-3">
								<app-status-icon [statusType]="StatusTypes.AffiliationApp"
									[statusCode]="league.affiliationApplicationStatusID"
									[statusName]="league.affiliationApplicationStatusName" size="sm" />
							</div>
							<div class="col">
								<span>Affiliation Application</span>
							</div>
						</div>
						<div class="row mb-1">
							<div class="col-3">
								<app-status-icon [statusType]="StatusTypes.LeagueAgreement"
									[statusCode]="league.isLeagueAgreementSubmitted ? LeagueAgreementStatusCodes.Submitted : LeagueAgreementStatusCodes.NotSubmitted"
									[statusName]="league.isLeagueAgreementSubmitted ? 'Submitted' : 'Not Submitted'"
									size="sm" />
							</div>
							<div class="col">
								<span>League Agreement</span>
							</div>
						</div>
						<div class="row">
							<div class="col-3">
								<app-status-icon [statusType]="StatusTypes.TournamentApp"
									[statusCode]="league.tournamentApplicationStatusID"
									[statusName]="league.tournamentApplicationStatusName" size="sm" />
							</div>
							<div class="col">
								<span>Tournament Application</span>
							</div>
						</div>

						<!-- team counts -->
						<hr class="mt-3 mb-1" />

						<div class="hstack gap-2 flex-wrap mt-3">
							<app-teams-badge [teamCount]="league.teamCount" [hasWarning]="league.hasTeamWarning"
								[showLabel]="true" />
							<app-players-badge [playerCount]="league.actualPlayerCount" [teamCount]="league.teamCount"
								[hasWarning]="league.hasPlayerWarning" [hasSuccess]="league.hasPlayerSuccess"
								[showLabel]="true" />
							<app-coaches-badge [coachCount]="league.actualCoachCount" [teamCount]="league.teamCount"
								[hasWarning]="league.hasCoachWarning" [showLabel]="true" />
							<app-documents-badge
								[inProgressCount]="league.requiredInProgressDocumentCount + league.optionalInProgressDocumentCount"
								[approvedCount]="league.requiredApprovedDocumentCount + league.optionalApprovedDocumentCount"
								[totalCount]="league.totalRequiredDocumentCount + league.totalOptionalDocumentCount"
								[hasWarning]="league.hasDocumentWarning" [hasSuccess]="league.hasDocumentSuccess"
								[showLabel]="true" />
						</div>

						<!-- league contacts -->
						<!-- primary contact -->
						@if (league.primaryContactName || league.primaryContactPhone ||
						league.primaryContactEmail) {
						<div class="small">
							<hr class="my-3" />

							@if (league.primaryContactName) {
							<div class="fw-medium">{{ league.primaryContactName }}</div>
							}
							@if (league.primaryContactPhone) {
							<div><a href="tel:{{ league.primaryContactPhone }}">{{
									league.primaryContactPhone }}</a></div>
							}
							@if (league.primaryContactEmail) {
							<div><a href="mailto:{{ league.primaryContactEmail }}">{{
									league.primaryContactEmail }}</a></div>
							}
						</div>
						}

						<!-- secondary contact -->
						@if (league.secondaryContactName ||
						league.secondaryContactPhone ||
						league.secondaryContactEmail) {
						<div class="small">
							<hr class="my-3" />

							@if (league.secondaryContactName) {
							<div class="fw-medium">{{ league.secondaryContactName }} <span
									class="fw-normal text-secondary">(secondary)</span>
							</div>
							}
							@if (league.secondaryContactPhone) {
							<div><a href="tel:{{ league.secondaryContactPhone }}">{{
									league.secondaryContactPhone }}</a></div>
							}
							@if (league.secondaryContactEmail) {
							<div><a href="mailto:{{ league.secondaryContactEmail }}">{{
									league.secondaryContactEmail }}</a></div>
							}
						</div>
						}
					</div>
				</div>
			</div>
			}
			}
		</div>
	</div>
</div>



<!-- INACTIVE LEAGUES -->
<!-- inactive leagues title -->
@if (authService.hasPermission(AppPermissionCodes.Leagues_Dashboard_Filter) && inactiveLeagues.length) {
<!-- d-none d-sm-flex -->
<div class="row mb-3">
	<div class="col">
		<h1>
			Inactive Leagues
			@if (inactiveLeagues.length) { <span class="text-secondary">({{ inactiveLeagues.length | number }})</span> }
			<fa-icon class="text-secondary ms-2" size="xs" [icon]="infoIcon"
				ngbTooltip="Leagues that did not affiliate with RBI during the current and previous league years." />
		</h1>
	</div>
</div>

<!-- inactive league listing -->
<div class="row mb-5">
	<div class="col">
		<!-- DESKTOP VIEW -->
		<div class="card d-none d-xl-flex" [class.border-0]="inactiveLeagues.length">
			<div class="card-body" [class.p-0]="inactiveLeagues.length">
				<div class="table-responsive">
					<table class="table table-hover table-bordered align-middle mb-0">
						<thead class="table-secondary">
							<tr>
								<th scope="col">League</th>
								<th scope="col">Contacts</th>
							</tr>
						</thead>
						<tbody>
							@for (league of inactiveLeagues; track league.leagueID; let isLast = $last, isOdd = $odd) {
							<tr class="stretchable-container table-row-clickable">
								<td>
									<div class="row g-2 align-items-center">
										@if (league.logoThumbnailURL) {
										<div class="col-auto">
											@defer (on viewport) {
											<app-document-thumbnail [thumbnailURL]="league.logoThumbnailURL"
												[isCircle]="false" />
											} @placeholder {
											<app-spinner />
											}
										</div>
										}
										<div class="col">
											<!-- league name -->
											<h5 class="hstack gap-2 mb-0">
												<a class="text-reset text-decoration-none stretched-link"
													[routerLink]="['/leagues/', league.leagueID]">{{
													league.leagueName
													}}</a>
												@if (league.isGuestAccess) { <span class="badge text-bg-light"
													ngbTooltip="Guest access"><fa-icon class="me-1"
														[icon]="guestUserIcon" /> Guest</span> }
												<app-years-badge [leagueYears]="league.affiliationYears || '-'" />
											</h5>
											<!-- league address -->
											@if (league.leagueFullAddress) {
											<div class="mt-1">
												<small class="text-secondary">
													{{ league.leagueFullAddress }}
												</small>
											</div>
											}
										</div>
									</div>
								</td>
								<td>
									<!-- primary contact -->
									<div class="small">
										@if (league.primaryContactName) {
										<div class="fw-medium">{{ league.primaryContactName }}</div>
										}
										@if (league.primaryContactPhone) {
										<div><a href="tel:{{ league.primaryContactPhone }}">{{
												league.primaryContactPhone }}</a></div>
										}
										@if (league.primaryContactEmail) {
										<div><a href="mailto:{{ league.primaryContactEmail }}">{{
												league.primaryContactEmail }}</a></div>
										}
									</div>

									<!-- contacts separator -->
									@if ((league.primaryContactName || league.primaryContactPhone ||
									league.primaryContactEmail) && (league.secondaryContactName ||
									league.secondaryContactPhone ||
									league.secondaryContactEmail)) {
									<hr class="my-2" />
									}

									<!-- secondary contact -->
									<div class="small">
										@if (league.secondaryContactName) {
										<div class="fw-medium">{{ league.secondaryContactName }} <span
												class="fw-normal text-secondary">(secondary)</span>
										</div>
										}
										<!-- @else {
																			<div>SECONDARY:</div>
																			} -->
										@if (league.secondaryContactPhone) {
										<div><a href="tel:{{ league.secondaryContactPhone }}">{{
												league.secondaryContactPhone }}</a></div>
										}
										@if (league.secondaryContactEmail) {
										<div><a href="mailto:{{ league.secondaryContactEmail }}">{{
												league.secondaryContactEmail }}</a></div>
										}
									</div>
								</td>
							</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<!-- MOBILE VIEW -->
		<div class="row g-3 d-flex d-xl-none">
			@for (league of inactiveLeagues; track league.leagueID; let isLast = $last, isOdd = $odd) {
			<div class="col-24 col-sm-12">
				<div class="card border-2">
					<div class="card-body">
						<!-- league title -->
						<div class="card-title c-pointer mb-0" [routerLink]="['/leagues/', league.leagueID]">
							<div class="d-flex justify-content-between">
								<h3 class="mb-0">
									@if (league.logoThumbnailURL) {
									<app-document-thumbnail class="me-1" [thumbnailURL]="league.logoThumbnailURL"
										[isCircle]="false" size="sm" />
									}
									{{ league.leagueName }}
								</h3>
								<app-details-icon ngbTooltip="View League Details" />
							</div>
							<div class="hstack gap-2 flex-wrap mt-2">
								@if (league.isGuestAccess) { <span class="badge text-bg-light"
									ngbTooltip="Guest access"><fa-icon [icon]="guestUserIcon" /></span> }
								<app-location-badge [countryCode]="league.countryCode" [zoneName]="league.zoneName" />
								<app-years-badge [leagueYears]="league.affiliationYears || '-'" />
							</div>
							<!-- league address -->
							@if (league.leagueFullAddress) {
							<div class="mt-2 small text-secondary">
								{{ league.leagueFullAddress }}
							</div>
							}
						</div>

						<!-- league contacts -->
						<!-- primary contact -->
						@if (league.primaryContactName || league.primaryContactPhone ||
						league.primaryContactEmail) {
						<div class="small">
							<hr class="my-3" />

							@if (league.primaryContactName) {
							<div class="fw-medium">{{ league.primaryContactName }}</div>
							}
							@if (league.primaryContactPhone) {
							<div><a href="tel:{{ league.primaryContactPhone }}">{{
									league.primaryContactPhone }}</a></div>
							}
							@if (league.primaryContactEmail) {
							<div><a href="mailto:{{ league.primaryContactEmail }}">{{
									league.primaryContactEmail }}</a></div>
							}
						</div>
						}

						<!-- secondary contact -->
						@if (league.secondaryContactName ||
						league.secondaryContactPhone ||
						league.secondaryContactEmail) {
						<div class="small">
							<hr class="my-3" />

							@if (league.secondaryContactName) {
							<div class="fw-medium">{{ league.secondaryContactName }} <span
									class="fw-normal text-secondary">(secondary)</span>
							</div>
							}
							@if (league.secondaryContactPhone) {
							<div><a href="tel:{{ league.secondaryContactPhone }}">{{
									league.secondaryContactPhone }}</a></div>
							}
							@if (league.secondaryContactEmail) {
							<div><a href="mailto:{{ league.secondaryContactEmail }}">{{
									league.secondaryContactEmail }}</a></div>
							}
						</div>
						}
					</div>
				</div>
			</div>
			}
		</div>
	</div>
</div>
}
